import React from 'react';
import Header from '../Encabezado/Encabezado';
import Footer from '../PiePagina/PiePagina';
import FloatingWhatsApp from '../InterfazUI/WhatsAppFlotante';
import { QuickViewModal } from '../UI/QuickViewModal';
import styles from './Plantilla.module.css';

export const Layout = ({ children }) => {
  return (
    <div className={styles.layoutWrapper}>
      <Header />
      <main className={styles.mainContent}>
        {children}
      </main>
      <Footer />
      <FloatingWhatsApp />
      <QuickViewModal />
    </div>
  );
};
export default Layout;
